require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/utils/anly-utils-suggestions.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/utils/anly-utils-suggestions.legacy.js
// module id = 789
// module chunks = 31